import { useCallback } from 'react';
import { useTracker } from '@archipro-website/tracker';

/** Logs `GoToCartButtonClick` as the reader follows a View Cart link. */
export const useTrackGoToCart = () => {
    const tracker = useTracker();
    return useCallback(() => {
        void tracker.log('GoToCartButtonClick', {
            url: new URL(window.location.href),
        });
    }, [tracker]);
};
